"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = _interopRequireWildcard(require("react-emotion"));
var _chevronUp = _interopRequireDefault(require("react-feather/dist/icons/chevron-up"));
var _chevronDown = _interopRequireDefault(require("react-feather/dist/icons/chevron-down"));
var _mediaQueries = _interopRequireDefault(require("../shared/mediaQueries"));
var _base = _interopRequireDefault(require("../shared/base"));
var _font = _interopRequireDefault(require("../shared/font"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var question = /*#__PURE__*/
(0, _reactEmotion.css)("background:white;padding:20px;display:flex;justify-content:space-between;align-items:center;font-weight:600;cursor:pointer;");
var answer = /*#__PURE__*/
(0, _reactEmotion.css)("background:rgba(255,255,255,0.6);padding:20px;");
var Container = /*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "e1pwxomu0"
})(_base.default, ";", _font.default, ";margin:20px 0;", (0, _mediaQueries.default)('md'), "{font-size:0.875rem;}");
var QuestionBlock = function QuestionBlock(_ref) {
  var open = _ref.open,
    children = _ref.children,
    toggleState = _ref.toggleState;
  return _react.default.createElement("div", {
    className: question,
    onClick: toggleState,
    role: "button",
    tabIndex: "0",
    onKeyPress: toggleState
  }, _react.default.createElement("div", null, children), open ? _react.default.createElement(_chevronUp.default, null) : _react.default.createElement(_chevronDown.default, null));
};
var AnswerBlock = function AnswerBlock(_ref2) {
  var open = _ref2.open,
    children = _ref2.children;
  return open ? _react.default.createElement("div", {
    className: answer
  }, children) : null;
};
var Faq = /*#__PURE__*/
function (_Component) {
  function Faq() {
    var _temp, _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_temp = _this = _Component.call.apply(_Component, [this].concat(args)) || this, _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      open: false
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleState", function () {
      _this.setState(function (_ref3) {
        var open = _ref3.open;
        return {
          open: !open
        };
      });
    }), _temp) || _assertThisInitialized(_this);
  }
  var _proto = Faq.prototype;
  _proto.render = function render() {
    var _this2 = this;

    // map over children to provide implicit state and props
    var children = _react.Children.map(this.props.children, function (child) {
      return (0, _react.cloneElement)(child, {
        open: _this2.state.open,
        toggleState: _this2.toggleState
      });
    });
    return _react.default.createElement(Container, null, children);
  };
  _inheritsLoose(Faq, _Component);
  return Faq;
}(_react.Component);
_defineProperty(Faq, "Question", QuestionBlock);
_defineProperty(Faq, "Answer", AnswerBlock);
QuestionBlock.propTypes = {
  open: _propTypes.bool,
  children: _propTypes.node,
  toggleState: _propTypes.func
};
AnswerBlock.propTypes = {
  children: _propTypes.node,
  open: _propTypes.bool
};
Faq.propTypes = {
  children: _propTypes.node
};
var _default = Faq;
exports.default = _default;